import { Reveal, Eyebrow } from "../components/primitives";
import CTABand from "../components/CTABand";
import { SERVICES } from "../data/content";

export default function Services() {
  const featured = SERVICES.find((s) => s.featured);
  const rest = SERVICES.filter((s) => !s.featured);

  return (
    <>
      <section className="bg-ivory pt-36 md:pt-48 pb-16" data-testid="services-hero">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
          <Reveal><Eyebrow>What We Do</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 font-serif font-light text-charcoal leading-[0.98] tracking-tight text-6xl md:text-8xl lg:text-[8vw]">
              Services
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl font-sans text-base md:text-lg text-charcoal/70 leading-[1.75] font-light">
              Everything we do leads with performance. The rest exists to feed it. Creative,
              influence and infrastructure engineered to move the numbers that matter.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Featured service */}
      <section className="bg-night text-ivory" data-testid="featured-service">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-3">
            <span className="font-serif text-6xl text-gold">01</span>
          </div>
          <div className="md:col-span-9">
            <Reveal>
              <h2 className="font-serif font-light text-ivory text-4xl md:text-6xl leading-tight tracking-tight">
                {featured.name}
              </h2>
              <p className="mt-6 max-w-2xl font-sans text-base md:text-lg text-ivory/70 leading-[1.75] font-light">
                {featured.desc}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Remaining services */}
      <section className="bg-ivory" data-testid="services-list">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-8 md:py-12">
          <ul className="divide-y divide-taupe">
            {rest.map((s, i) => (
              <Reveal key={s.name} delay={i * 0.04}>
                <li className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 py-10 md:py-14 items-baseline">
                  <div className="md:col-span-1">
                    <span className="font-serif text-2xl text-gold">{String(i + 2).padStart(2, "0")}</span>
                  </div>
                  <div className="md:col-span-5">
                    <h3 className="font-serif text-3xl md:text-5xl text-charcoal font-light group-hover:text-gold transition-colors duration-300">
                      {s.name}
                    </h3>
                  </div>
                  <div className="md:col-span-6">
                    <p className="font-sans text-base md:text-lg text-charcoal/65 leading-[1.75] font-light">
                      {s.desc}
                    </p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <CTABand title="Book a strategy call and let's scale your brand." />
    </>
  );
}
